import { freeze } from "@/lib/utils/collections"

export interface DayObject {
  year: number // Full year, like 2023
  month: number // 1-12
  day: number // 1-31
}

export interface Timestamp {
  epoch_millis: number
}

export interface TimeOfDay {
  hour: number // 0-23
  minute: number // 0-59
  second?: number // 0-59
  millisecond?: number // 0-999
}
export type DetailedTimeOfDay = Required<TimeOfDay>
export const START_OF_DAY = freeze<DetailedTimeOfDay>({
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0,
})
export const END_OF_DAY = freeze<DetailedTimeOfDay>({
  hour: 23,
  minute: 59,
  second: 59,
  millisecond: 999,
})

export interface DayRange {
  from: DayObject | undefined
  to?: DayObject | undefined
}
export type FixedDayRange = {
  from: DayObject
  to: DayObject
}

export function isFixedDayRange(
  range: DayRange | undefined
): range is FixedDayRange {
  return range?.from !== undefined && range?.to !== undefined
}

export interface TimeRange {
  from: Timestamp | undefined
  to?: Timestamp | undefined
}
export interface FixedTimeRange extends TimeRange {
  from: Timestamp
  to: Timestamp
}
export type Frequency = "day" | "week" | "month"
